import { render, staticRenderFns } from "./VideoMessage.vue?vue&type=template&id=0f4ce1dc&scoped=true"
import script from "./VideoMessage.vue?vue&type=script&lang=js"
export * from "./VideoMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ce1dc",
  null
  
)

export default component.exports